<template>
	<pop-up-wrapper @close="close">
		<div ref="popUp" :style="pos" class="pop-up-create-drive-element">
			<p @click="showPopUpFolder">
				<img src="/img/class/folder-icon.svg" alt="" /> Dossier
			</p>
			<hr />
			<label for="file" @click="showPopUpEdit">
				<img src="/img/class/file-icon.svg" alt="" /> Importer un
				fichier
			</label>
			<input
				@change="updateFile"
				style="display: none"
				id="file"
				type="file"
				:accept="acceptedFileTypes"
			/>
			<div class="file-info">
				<small>Taille maximale : {{ maxFileSizeMB }} MB</small>
				<small>Types acceptés : {{ acceptedExtensionsText }}</small>
			</div>
		</div>
	</pop-up-wrapper>
</template>

<script>
import { createFileService } from '../../../services/filesService'
import PopUpWrapper from '../PopUpWrapper.vue'
import { isFileAccepted, isFileSizeValid, getMaxFileSize, getAllAcceptedExtensions } from '../../../utils/fileTypes'
export default {
	components: { PopUpWrapper },
	props: {
		x: Number,
		y: Number
	},
	data() {
		return {
			inputValue: '',
			delete: false,
			pos: '',
			file: {}
		}
	},
	computed: {
		// Taille maximale en MB pour l'affichage
		maxFileSizeMB() {
			return getMaxFileSize() / (1024 * 1024)
		},
		// Extensions acceptées pour l'attribut accept de l'input
		acceptedFileTypes() {
			return getAllAcceptedExtensions().map(ext => `.${ext}`).join(',')
		},
		// Texte des extensions acceptées pour l'affichage
		acceptedExtensionsText() {
			return getAllAcceptedExtensions().join(', ')
		}
	},
	methods: {
		async updateFile(e) {
			this.file = e.target.files[0]
			
			// Vérification de l'extension du fichier
			if (!isFileAccepted(this.file.name)) {
				const acceptedExtensions = getAllAcceptedExtensions().join(', ')
				this.$store.state.toast = {
					status: 'error',
					text: `Type de fichier non accepté. Extensions acceptées : ${acceptedExtensions}`,
				}
				e.target.value = '' // Réinitialiser l'input
				return
			}
			
			// Vérification de la taille du fichier
			if (!isFileSizeValid(this.file.size)) {
				const maxSizeMB = getMaxFileSize() / (1024 * 1024)
				this.$store.state.toast = {
					status: 'error',
					text: `Fichier trop volumineux. Taille maximale : ${maxSizeMB} MB`,
				}
				e.target.value = '' // Réinitialiser l'input
				return
			}
			
			const data = new FormData()

			data.append('name', this.file.name)
			data.append('class_id', this.$route.params.id)
			data.append('file_upload', this.file)
			if (this.$route.params.folderId) {
				data.append('parent_folder_id', this.$route.params.folderId)
			}

			try {
				await createFileService(data)
				this.$store.state.toast = {
					status: 'success',
					text: 'Fichier uploadé avec succès',
				}
				this.$emit('close')
				this.$emit('getFiles')
			} catch (error) {
				this.$store.state.toast = {
					status: 'error',
					text: 'Erreur lors de l\'upload du fichier',
				}
				e.target.value = '' // Réinitialiser l'input
			}
		},

		close() {
			this.$emit('closed')
		},
		showPopUpFolder() {
			this.$emit('newFolder')
			this.$emit('close')
		},
		showPopUpEdit() {
			this.$emit('showPopUpEdit')
			this.$emit('closed')
		},

	},

	mounted() {
		const height = window.innerHeight
		const popUpHeight = this.$refs.popUp.clientHeight

		let x = this.x
		let y = this.y

		if (y > height - popUpHeight) {
			y = height - popUpHeight - 20
		}
		let style = `left: calc(${x}px - 15vw); top: ${y}px;`
		this.pos = style
	},
}
</script>

<style>
.file-info {
	margin-top: 10px;
	padding: 8px;
	background-color: #f5f5f5;
	border-radius: 4px;
	font-size: 12px;
	color: #666;
}

.file-info small {
	display: block;
	margin-bottom: 4px;
}

.file-info small:last-child {
	margin-bottom: 0;
}
</style>
